import React from 'react'
import { CreateRfqModal } from '../../../components/enterprise/CreateRfqModal'

interface GovRfqModalProps {
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
  userRole: 'ENTERPRISE_VENDOR' | 'AGENCY' | 'ADMIN' | 'GOV_EMAIL'
}

export const GovRfqModal: React.FC<GovRfqModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  userRole: _userRole
}) => {
  return (
    <CreateRfqModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  )
}